import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactPlayer from 'react-player';
import GuardAndPatrolVideo from '../../images/GUARDANDPATROL.mp4';
import IncidentResponseVideo from '../../images/INCIDENTRESPONSE.mp4';
import ThreatVideo from '../../images/THREATOBSERVATION.mp4';

//2nd acadamic
import GuardAndPatrol from '../../Assets/TrainingVideos/2025-26/GUARD_AND_PATROL.mp4';
import RTTVideo from '../../Assets/TrainingVideos/2025-26/RTT_E_LEARNING.mp4';
import Security from '../../Assets/TrainingVideos/2025-26/SECURITY_INCIDENTS.mp4';
import Apiservice from '../Apiservice';

const OverviewOfCourse = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [acadamics, setAcadamics] = useState([]);
    const [selectedAcademic, setSelectedAcademic] = useState(2);
    const [exams, setExams] = useState([]);
    const [examLine, setExamLine] = useState("");
    const [loading, setLoading] = useState(false)

    // const [selectedAcademic, setSelectedAcademic] = useState(currentAcademic);
    useEffect(() => {
        if (location.state?.sectionId) {
            const section = document.getElementById(location.state.sectionId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location.state?.sectionId]);

    useEffect(() => {
        if (location.state?.academicId) {
            setSelectedAcademic(location.state.academicId)
        }
    }, [location.state?.academicId]);

    useEffect(() => {
        const fetchData = async () => {
            let data = { "status": 0 }
            let result = await Apiservice.AcadamicsGet(data);
            if (result.success) {
                setAcadamics(result.data);
            } else {
                alert(result.message)
            }
        };
        fetchData();
    }, []);


    useEffect(() => {
        let academicExam = acadamics.find(
            (acadamic) => acadamic.id === selectedAcademic
        );
        setExams(academicExam?.exams || []);
    }, [selectedAcademic, acadamics]);

    useEffect(() => {
        const line = exams.map(exam => exam.name).join(", ");
        setExamLine(line);
    }, [exams]);

    // useEffect(() => {
    //     if (selectedAcademic == "2025") {
    //         setExams([
    //             { id: 2, name: 'Incident Response Training Video', video: IncidentResponseVideo, noOfQuestions: 10 },
    //             { id: 3, name: 'Guard & Patrol Training Video', video: GuardAndPatrolVideo, noOfQuestions: 10 },
    //             { id: 1, name: 'Threat Observation Training Video', video: ThreatVideo, noOfQuestions: 10 },
    //         ]);
    //     }
    //     if (selectedAcademic == "2026") {
    //         setExams([
    //             { id: 4, name: 'Provide Guard & Patrol Services', video: GuardAndPatrol, noOfQuestions: 0 },
    //             { id: 5, name: 'Handle Security Incidents and Services', video: Security, noOfQuestions: 0 },
    //             { id: 6, name: 'Recognise Terrorist Threads', video: RTTVideo, noOfQuestions: 0 },
    //         ]);
    //     }

    // }, [selectedAcademic, acadamics])

    return (
        <div className="container-fluid py-md-3 p-0 shadow" style={{userSelect: 'none' }} id='4'>
            <div className="row justify-content-center" >
                <div className="col-12 col-md-10">
                    <div className="row mb-4 p-md-2 bg-white shadow-sm rounded" >
                        <div className="col-12">
                            <h3 className="text-center mb-3" >Overview of Course</h3>
                            <ul className="text-justify">
                                <li>This course is a continuous training program for security officers.</li>
                                <li>The topics covered include {examLine}</li>
                                <li id='1'>Watch all the training videos and complete the quiz.</li>
                            </ul>

                            {/* Inline styles to ensure text justification */}
                            <style jsx="true">{`
        @media (max-width: 768px) {
            .text-justify {
                text-align: justify;
            }
        }
    `}</style>
                        </div>

                    </div>

                    {/* Modern Academic Tabs */}
                    <div className="d-flex justify-content-center flex-wrap gap-3 mb-4">
                        {acadamics.map((acadamic) => {
                            const isActive = selectedAcademic === acadamic.id;

                            return (
                                <button
                                    key={acadamic.id}
                                    onClick={() => setSelectedAcademic(acadamic.id)}
                                    style={{
                                        border: isActive
                                            ? "1px solid #0d6efd"
                                            : "1px solid #dee2e6",
                                        background: isActive
                                            ? "linear-gradient(135deg, #0d6efd, #4f8cff)"
                                            : "#ffffff",
                                        color: isActive ? "#fff" : "#495057",
                                        padding: "10px 22px",
                                        borderRadius: "50px",
                                        fontSize: "14px",
                                        fontWeight: isActive ? "600" : "500",
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        boxShadow: isActive
                                            ? "0 6px 18px rgba(13,110,253,0.25)"
                                            : "0 2px 8px rgba(0,0,0,0.06)",
                                        transform: isActive ? "translateY(-2px)" : "translateY(0)",
                                        minWidth: "120px",
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!isActive) {
                                            e.currentTarget.style.background = "#f8f9fa";
                                            e.currentTarget.style.transform = "translateY(-2px)";
                                            e.currentTarget.style.boxShadow =
                                                "0 6px 16px rgba(0,0,0,0.10)";
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!isActive) {
                                            e.currentTarget.style.background = "#ffffff";
                                            e.currentTarget.style.transform = "translateY(0)";
                                            e.currentTarget.style.boxShadow =
                                                "0 2px 8px rgba(0,0,0,0.06)";
                                        }
                                    }}
                                >
                                    {acadamic.acadamic}
                                </button>
                            );
                        })}
                    </div>
                    {
                        selectedAcademic == "" ? (
                            <h4 className="text-center">Please select academic</h4>
                        ) : exams.length > 0 ? (
                            exams.map((exam) => (
                                <div
                                    key={exam.id}
                                    id={exam.id}
                                    className="row mb-4 bg-white shadow-sm rounded"
                                >
                                    <div className="col-12 p-md-2 p-1">
                                        <h5 className="text-center">{exam.name} Training Video</h5>
                                        <div className="video-container mb-3">
                                            <ReactPlayer
                                                url={exam.video}
                                                width="100%"
                                                height="100%"
                                                controls
                                                className="video-player"
                                            />
                                        </div>
                                        {
                                            exam.noOfQuestions > 0 && (
                                                <div className="d-flex justify-content-center">
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() => navigate(`/quiz/${exam.id}`)}
                                                    >
                                                        Take Quiz
                                                    </button>
                                                </div>
                                            )
                                        }

                                    </div>
                                </div>
                            ))
                        )
                            : <h4>No exams available</h4>
                    }
                </div>
            </div>

            {/* Styles for responsive design */}
            <style jsx="true">{`
                .video-container {
                    position: relative;
                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                    width: 100%;
                    height: 0;
                    overflow: hidden;
                }
                .video-player {
                    position: absolute;
                    top: 0;
                    left: 0;
                }
                @media (max-width: 768px) {
                    h3, h5 {
                        font-size: 1.2rem;
                    }
                    .btn {
                        font-size: 0.9rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default OverviewOfCourse;
